export default __webpack_public_path__ + "static/media/PendingRelocationIcon.5fe6d5bf.svg";